{
  "files.title": "Files",
  "files.description": "Attach safe files to this record and manage their lifecycle without losing revision history.",
  "files.expand": "Show files",
  "files.collapse": "Hide files",
  "files.add": "Add file",
  "files.quota": "Storage quota",
  "files.quota_value": "{{used}} of {{limit}} used",
  "files.quota_detail": "{{available}} available · {{reserved}} reserved by uploads in progress",
  "files.quota_error": "Storage quota could not be loaded.",
  "files.show_trash": "Include files in Trash",
  "files.load_error": "Files could not be loaded",
  "files.empty": "No files attached",
  "files.empty_description": "Add a document, image, or other supporting file to keep it with this record.",
  "files.trash_empty": "Trash is empty",
  "files.trash_empty_description": "Trashed attachments will appear here until their purge date.",
  "files.status.trashed": "In Trash",
  "files.download": "Download",
  "files.download_error": "The file could not be downloaded",
  "files.edit": "Edit",
  "files.trash": "Move to Trash",
  "files.restore": "Restore",
  "files.purge": "Delete permanently",
  "files.trashed": "File moved to Trash",
  "files.restored": "File restored",
  "files.purged": "File permanently deleted",
  "files.purge_after": "Scheduled for deletion after {{date}}",
  "files.trash_confirm_title": "Move this file to Trash?",
  "files.trash_confirm_description": "{{name}} can be restored until it is permanently deleted.",
  "files.purge_title": "Permanently delete this file?",
  "files.purge_description": "{{name}} and its stored bytes will be removed. This cannot be undone.",
  "files.purge_confirmation": "Confirmation",
  "files.purge_confirmation_hint": "Type DELETE exactly to continue.",
  "files.upload_title": "Attach a file",
  "files.upload_description": "The file is reserved, checked, uploaded, and attached in separate safe stages.",
  "files.select": "Choose file",
  "files.caption": "Caption",
  "files.upload": "Upload and attach",
  "files.upload_progress": "Preparing and checking file",
  "files.upload_success": "File attached",
  "files.upload_error": "The file could not be attached",
  "files.over_quota": "This file is larger than the {{available}} currently available.",
  "files.policy_error": "The active extension's file rules could not be loaded. Upload remains unavailable.",
  "files.policy_limit": "This record has reached the active extension's attachment limit.",
  "files.policy_rejected": "This file does not match the active extension's upload rules.",
  "files.policy_summary": "{{types}} · up to {{size}} · {{count}} per record",
  "files.edit_title": "Edit file details",
  "files.name": "Display name",
  "files.save": "Save",
  "files.saved": "File details saved",
  "files.cancel": "Cancel",
  "files.action_error": "The file action could not be completed",
  "files.action_error_description": "Try again after refreshing the file list.",
  "files.size": "{{value}} {{unit}}",
  "files.unit.b": "B",
  "files.unit.kb": "KB",
  "files.unit.mb": "MB",
  "files.unit.gb": "GB",
  "files.unit.tb": "TB",

  "reminders.title": "Reminder rules",
  "reminders.description": "Create, revise, archive, and audit durable reminders across your records.",
  "reminders.source_description": "Rules attached to {{source}}.",
  "reminders.add": "Add reminder",
  "reminders.show_archived": "Include archived rules",
  "reminders.refresh": "Refresh",
  "reminders.load_error": "Reminder rules could not be loaded",
  "reminders.empty": "No reminder rules",
  "reminders.empty_description": "Create a rule to turn an important moment into a durable occurrence.",
  "reminders.enabled": "Enabled",
  "reminders.disabled": "Disabled",
  "reminders.archived_badge": "Archived",
  "reminders.edit": "Edit",
  "reminders.history": "History",
  "reminders.materialize": "Refresh occurrences",
  "reminders.materialized": "{{count}} occurrences are now available",
  "reminders.materialize_offset_title": "Which source time should this offset use?",
  "reminders.materialize_offset_description": "Offset reminders need the source event's current time before Exognitos can safely create occurrences.",
  "reminders.materialize_source_at": "Source date and time",
  "reminders.materialize_source_at_hint": "The configured {{minutes}}-minute offset is added to this instant.",
  "reminders.archive": "Archive",
  "reminders.restore": "Restore",
  "reminders.archived": "Reminder rule archived",
  "reminders.restored": "Reminder rule restored",
  "reminders.archive_title": "Archive this reminder rule?",
  "reminders.archive_description": "{{title}} will stop producing new occurrences. Its history stays available.",
  "reminders.delivery_summary": "{{timezone}} · {{channels}} · Quiet hours: {{quiet}}",
  "reminders.source_summary": "Source: {{type}} · {{id}}",
  "reminders.occurrences_title": "Occurrences",
  "reminders.occurrences_description": "The scheduled delivery truth for the next 90 days, including snoozed and resolved items.",
  "reminders.occurrences_error": "Reminder occurrences could not be loaded",
  "reminders.occurrences_empty": "No occurrences in this window",
  "reminders.occurrences_empty_description": "Create or refresh a rule to materialize upcoming occurrences.",
  "reminders.occurrence_updated": "Reminder occurrence updated",
  "reminders.ack": "Done",
  "reminders.snooze": "Snooze 10 min",
  "reminders.cancel_occurrence": "Cancel occurrence",
  "reminders.create_title": "Create reminder rule",
  "reminders.edit_title": "Edit reminder rule",
  "reminders.editor_description": "Times use the selected IANA timezone. Revisions prevent overwriting changes from another device.",
  "reminders.source_type": "Source type",
  "reminders.source_id": "Source record ID",
  "reminders.source_id_hint": "Use the UUID of the record that owns this reminder.",
  "reminders.source_revision": "Source revision",
  "reminders.rule_title": "Reminder title",
  "reminders.body": "Message",
  "reminders.trigger_type": "Trigger",
  "reminders.trigger.absolute": "Specific date and time",
  "reminders.trigger.offset": "Offset from source time",
  "reminders.trigger.recurrence": "Repeating schedule",
  "reminders.absolute_at": "Date and time",
  "reminders.offset_minutes": "Offset minutes",
  "reminders.offset_hint": "Use a negative number for before the source time, zero for the same time, or a positive number for after it.",
  "reminders.frequency": "Frequency",
  "reminders.frequency.daily": "Daily",
  "reminders.frequency.weekly": "Weekly",
  "reminders.recurrence_time": "Local time",
  "reminders.start_date": "Start date",
  "reminders.end_date": "End date (optional)",
  "reminders.weekdays": "Weekdays",
  "reminders.weekday.1": "Mon",
  "reminders.weekday.2": "Tue",
  "reminders.weekday.3": "Wed",
  "reminders.weekday.4": "Thu",
  "reminders.weekday.5": "Fri",
  "reminders.weekday.6": "Sat",
  "reminders.weekday.7": "Sun",
  "reminders.timezone": "Timezone",
  "reminders.timezone_hint": "Use an IANA name such as Europe/Istanbul.",
  "reminders.channels": "Delivery channels",
  "reminders.channel.in_app": "In-app inbox",
  "reminders.channel.web_push": "Browser push",
  "reminders.web_push_hint": "Browser permission and an active push subscription are also required.",
  "reminders.quiet_behavior": "During quiet hours",
  "reminders.quiet_hint": "This rule follows the account quiet-hours window.",
  "reminders.quiet.delay": "Delay until quiet hours end",
  "reminders.quiet.suppress": "Suppress the occurrence",
  "reminders.quiet.deliver": "Deliver anyway",
  "reminders.enabled_label": "Rule is enabled",
  "reminders.dst_note": "Recurring times stay anchored to this timezone. On daylight-saving transitions, the server resolves missing or repeated local times consistently and keeps the original planned instant in history.",
  "reminders.cancel": "Cancel",
  "reminders.create": "Create rule",
  "reminders.save": "Save changes",
  "reminders.created": "Reminder rule created",
  "reminders.saved": "Reminder rule saved",
  "reminders.history_title": "Reminder history",
  "reminders.history_error": "Reminder history could not be loaded",
  "reminders.history_empty": "No revisions recorded",
  "reminders.close": "Close",
  "reminders.revision": "Revision {{revision}}",
  "reminders.untitled": "Untitled reminder",
  "reminders.offset_summary": "{{minutes}} minutes before the source time",
  "reminders.offset_before": "{{minutes}} minutes before the source time",
  "reminders.offset_after": "{{minutes}} minutes after the source time",
  "reminders.offset_at_source": "At the source time",
  "reminders.recurrence_summary": "{{frequency}} at {{time}} {{days}}",
  "reminders.action_error": "The reminder action could not be completed",
  "reminders.action_error_description": "Refresh the rule and try again.",
  "reminders.validation.source": "Enter a valid source record UUID.",
  "reminders.validation.title": "Enter a reminder title.",
  "reminders.validation.revision": "Source revision must be a whole number of 1 or greater.",
  "reminders.validation.timezone": "Enter a valid IANA timezone.",
  "reminders.validation.channel": "Choose at least one delivery channel.",
  "reminders.validation.absolute": "Choose a valid date and time.",
  "reminders.validation.offset": "Enter an offset between -525600 and 525600 minutes.",
  "reminders.validation.recurrence": "Choose a valid start date and local time.",
  "reminders.validation.weekdays": "Choose at least one weekday.",
  "reminders.validation.end_date": "End date cannot be before start date.",
  "reminders.source.task": "Task",
  "reminders.source.routine": "Routine",
  "reminders.source.project": "Project",
  "reminders.source.plan": "Plan",
  "reminders.source.note": "Note",
  "reminders.source.knowledge_item": "Knowledge item",
  "reminders.source.life_item": "Life record",
  "reminders.state.planned": "Planned",
  "reminders.state.due": "Due",
  "reminders.state.snoozed": "Snoozed",
  "reminders.state.acknowledged": "Done",
  "reminders.state.cancelled": "Cancelled",
  "reminders.state.suppressed": "Suppressed",
  "reminders.manage_title": "Manage all reminder rules",
  "reminders.manage_description": "Review schedules, occurrences, archives, and revision history in one place.",
  "reminders.manage": "Open reminder manager",

  "backup.browser_title": "Backup restore continues in your browser",
  "backup.browser_description": "Archive export and replacement restore use browser streaming and first-party session checks. Native offline data remains available below.",
  "backup.continue_browser": "Continue in browser",
  "backup.export_v11": "Export signed archive",
  "backup.export_legacy": "Export legacy JSON",
  "backup.export_description": "The signed V11 archive is the complete, integrity-checked backup. Legacy JSON export and restore remain available for older clients.",
  "backup.format_v11": "Signed archive V{{version}}",
  "backup.format_legacy": "Legacy web backup",
  "backup.integrity_verified": "Integrity verified",
  "backup.integrity_failed": "Integrity not verified",
  "backup.signature_verified": "Signature verified",
  "backup.signature_failed": "Signature not verified",
  "backup.legacy_warning": "Legacy backup: compatibility checks only; no archive signature is available.",
  "backup.confirm_label": "Replacement confirmation",
  "backup.confirm_hint": "Type REPLACE exactly. Current server data will be replaced after the verified preview is checked again.",

  "calendar.portability.title": "Calendar portability",
  "calendar.portability.description": "Export this view, preview iCalendar imports, and manage revocable subscription feeds.",
  "calendar.portability.expand": "Open portability tools",
  "calendar.portability.collapse": "Hide portability tools",
  "calendar.export.title": "Export this calendar view",
  "calendar.export.description": "Download scheduled items from {{from}} through {{to}} as a standard .ics file.",
  "calendar.export.name": "Calendar name",
  "calendar.export.action": "Export .ics",
  "calendar.export.success": "Calendar exported",
  "calendar.import.title": "Import iCalendar",
  "calendar.import.description": "Preview every create, update, duplicate, conflict, and unsupported recurrence before anything is written.",
  "calendar.import.file": "Choose an iCalendar file",
  "calendar.import.project": "Target project",
  "calendar.import.project_hint": "Imported tasks can remain personal or be assigned to one project.",
  "calendar.import.unassigned": "Personal calendar (no project)",
  "calendar.import.preview": "Preview import",
  "calendar.import.preview_error": "The calendar could not be previewed",
  "calendar.import.file_too_large": "Choose an iCalendar file smaller than 2 MB.",
  "calendar.import.creates": "{{count}} new",
  "calendar.import.updates": "{{count}} updates",
  "calendar.import.duplicates": "{{count}} duplicates",
  "calendar.import.conflicts": "{{count}} conflicts",
  "calendar.import.unsupported": "{{count}} unsupported",
  "calendar.import.expires": "Preview expires {{date}}",
  "calendar.import.apply_updates": "Apply safe updates to previously imported events",
  "calendar.import.apply_updates_hint": "Off by default so a local edit is never overwritten silently.",
  "calendar.import.bind_duplicates": "Link exact duplicates without creating another task",
  "calendar.import.bind_duplicates_hint": "Keeps future imports idempotent while preserving the existing record.",
  "calendar.import.apply": "Apply reviewed import",
  "calendar.import.confirm_title": "Apply this calendar import?",
  "calendar.import.confirm_description": "This will create {{creates}} records and apply {{updates}} reviewed updates. Conflicts remain skipped.",
  "calendar.import.success": "Calendar import applied",
  "calendar.import.success_detail": "{{created}} created · {{updated}} updated · {{skipped}} skipped",
  "calendar.import.disposition.create": "Create",
  "calendar.import.disposition.update": "Update",
  "calendar.import.disposition.duplicate": "Duplicate",
  "calendar.import.disposition.conflict": "Conflict",
  "calendar.import.disposition.unsupported_recurrence": "Unsupported recurrence",
  "calendar.subscriptions.title": "Subscription feeds",
  "calendar.subscriptions.description": "Create read-only bearer links for calendar apps. Rotate a leaked link or revoke it immediately.",
  "calendar.subscriptions.add": "New feed",
  "calendar.subscriptions.error": "Subscription feeds could not be loaded",
  "calendar.subscriptions.empty": "No subscription feeds",
  "calendar.subscriptions.empty_description": "Create a feed to subscribe from another calendar app.",
  "calendar.subscriptions.active": "Active",
  "calendar.subscriptions.revoked_badge": "Revoked",
  "calendar.subscriptions.secret_hint": "Secret ends in {{hint}}",
  "calendar.subscriptions.rotated": "Rotated {{date}}",
  "calendar.subscriptions.edit": "Edit",
  "calendar.subscriptions.rotate": "Rotate link",
  "calendar.subscriptions.revoke": "Revoke",
  "calendar.subscriptions.rotate_title": "Rotate this subscription link?",
  "calendar.subscriptions.rotate_description": "The current bearer link will stop working immediately. You will receive a new link once.",
  "calendar.subscriptions.revoke_title": "Revoke this subscription feed?",
  "calendar.subscriptions.revoke_description": "Subscribed apps will stop receiving updates immediately. Revocation cannot be undone.",
  "calendar.subscriptions.revoked": "Subscription feed revoked",
  "calendar.subscriptions.create_title": "Create subscription feed",
  "calendar.subscriptions.edit_title": "Edit subscription feed",
  "calendar.subscriptions.editor_description": "Choose a bounded rolling calendar view. Feed content is generated by the server; the secret is shown only once.",
  "calendar.subscriptions.name": "Feed name",
  "calendar.subscriptions.project": "Project filter",
  "calendar.subscriptions.project_hint": "Choose any combination of project calendars and the personal calendar below.",
  "calendar.subscriptions.all_projects": "All project calendars",
  "calendar.subscriptions.include_unassigned": "Include personal, projectless items",
  "calendar.subscriptions.window_hint": "The feed includes the previous 30 days and upcoming 365 days in your selected timezone.",
  "calendar.subscriptions.saved": "Subscription feed saved",
  "calendar.subscriptions.created": "Subscription feed created",
  "calendar.subscriptions.secret_title": "Save this subscription link now",
  "calendar.subscriptions.secret_description": "For security, the full bearer secret will not be shown again.",
  "calendar.subscriptions.copy": "Copy feed link",
  "calendar.subscriptions.copied": "Feed link copied",
  "calendar.subscriptions.copy_error": "Feed link could not be copied",
  "calendar.subscriptions.secret_warning": "Anyone with this link can read the selected calendar. Rotate it if it is exposed.",
  "calendar.subscriptions.secret_done": "I saved the link",
  "calendar.cancel": "Cancel",
  "calendar.save": "Save",
  "calendar.create": "Create feed",
  "calendar.action_error": "The calendar action could not be completed",
  "calendar.action_error_description": "Refresh the calendar data and try again.",
  "settings.identity_hub.title": "Your profile and assistant access",
  "settings.identity_hub.description": "Review the facts Exognitos uses to understand you and control every assistant connection from one place.",
  "settings.identity_hub.profile": "Open profile",
  "settings.identity_hub.connections": "Assistant connections",
  "settings.identity_hub.memory": "Assistant memory"
}
